"use client";
import React, { useState } from "react";
import toast from "react-hot-toast";
import userService from "@/services/user-service";
import { useAuth } from "@/hooks/useAuth";
import strings from "../../strings";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * "Pozabljeno geslo" / "Spremeni geslo": the visitor gives the e-mail of the account and gets a link by
 * e-mail. The link opens the page where the new password and its repeat are entered. Logged in
 * (My account), the field starts with the account's own e-mail.
 */
export default function ForgotPasswordForm({ onDone }) {
  const { user } = useAuth();
  const [typedEmail, setTypedEmail] = useState(null);
  const [sending, setSending] = useState(false);
  const [sentTo, setSentTo] = useState("");
  const email = typedEmail ?? user?.email ?? "";

  const send = async () => {
    const address = email.trim();
    if (!EMAIL_REGEX.test(address)) {
      toast.error("Vnesi veljaven e-naslov");
      return;
    }
    if (sending) return;
    setSending(true);
    const response = await userService.requestNewPassword(address);
    setSending(false);
    if (response.error) {
      toast.error(response.error);
      return;
    }
    setSentTo(address);
  };

  if (sentTo) {
    return (
      <div>
        <div className="text-[24px] text-[#1E2125] leading-[28px] font-variation-customOpt24 mobile:text-[20px] mobile:leading-[23px]">
          Preveri e-pošto
        </div>
        <p className="mt-[32px] text-[14px] leading-[20px] text-[#3C3E41]">
          Na <strong>{sentTo}</strong> smo ti poslali povezavo, preko katere lahko določiš novo
          geslo. Če sporočila ni, preveri tudi mapo z vsiljeno pošto (spam).
        </p>
        {onDone && (
          <button
            type="button"
            onClick={onDone}
            className="mt-[32px] h-[50px] w-full rounded-[10px] bg-gradient-to-b from-[#0D94E8] to-[#0A85C2] text-white"
          >
            V redu
          </button>
        )}
      </div>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
    >
      <div className="text-[24px] text-[#1E2125] leading-[28px] font-variation-customOpt24 mobile:text-[20px] mobile:leading-[23px] mobile:font-variation-customOpt20">
        {strings.PozabljenoGeslo}
      </div>

      <div className="mt-[32px] text-[14px] leading-[20px] text-[#3C3E41]">
        Vnesi e-naslov, ki si ga uporabil pri registraciji. Nanj ti pošljemo povezavo, kjer izbereš
        novo geslo.
      </div>

      <div className="mt-[10px] h-[40px] w-full rounded-[6px] bg-[#F2F8FF66] shadow-custom-dark-to-white">
        <input
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setTypedEmail(e.target.value)}
          placeholder="E-naslov"
          className="h-full w-full bg-transparent px-[19px] text-[15px] text-[#1E2125] focus:outline-none"
        />
      </div>

      <button
        type="submit"
        disabled={sending}
        className="mt-[32px] flex h-[50px] w-full items-center justify-center rounded-[10px] bg-gradient-to-b from-[#0D94E8] to-[#0A85C2] text-white shadow-custom-dark-bottom disabled:opacity-60"
      >
        {sending ? "Pošiljam…" : "POŠLJI POVEZAVO"}
      </button>

      <div className="mt-[32px] text-[#6D778E] mobile:text-[13px] mobile:leading-[20px]">
        Če imaš težave pri obnovitvi računa, lahko pošlješ sporočilo na{" "}
        <span className="text-[#0A85C2]">Pomoč uporabnikom.</span> Običajno odgovorimo še isti dan.
      </div>
    </form>
  );
}
